import type { IconData } from '@stacksjs/iconify-core'

export const healthVirus: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M8 0a8 8 0 0 0-2.942.558l2.02 2.02A5.5 5.5 0 0 0 3.764 4.49l-.738-2.757A8 8 0 0 0 1.142 3.88l-.148.255a8 8 0 0 0-.909 2.693l2.756-.739A5.5 5.5 0 0 0 2.5 8c0 .672.12 1.317.341 1.912L.085 9.174c.142.965.457 1.875.912 2.696l.142.247a8 8 0 0 0 1.888 2.15l.738-2.757a5.5 5.5 0 0 0 3.312 1.913l-2.019 2.019A8 8 0 0 0 8 16a8 8 0 0 0 2.942-.558l-2.019-2.02a5.5 5.5 0 0 0 3.312-1.912l.738 2.757a8 8 0 0 0 1.887-2.15l.143-.247c.455-.821.77-1.73.911-2.696l-2.756.738A5.5 5.5 0 0 0 13.5 8c0-.672-.12-1.316-.341-1.912l2.755.739a8 8 0 0 0-.908-2.693l-.148-.255a8 8 0 0 0-1.885-2.146l-.738 2.757a5.5 5.5 0 0 0-3.312-1.913L10.942.558A8 8 0 0 0 8 0\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default healthVirus
